module.exports = __webpack_public_path__ + "static/media/simona_micevska.0f32072e.jpeg";